import React, { Component } from 'react'
import { Form } from 'semantic-ui-react'

export default function Radios(props) {
  let { options = [], name, value: inputValue, onChange, disabled, inline = false } = props

  if (!Array.isArray(options)) return <span>Radios options needs to be an array</span>

  let classes = ['form-input', 'form-input-radios']
  if (inline) classes.push('form-input-radios--inline')

  return (
    <div className={classes.join(' ')}>
      {options.map(({ label, value }) => (
        <Form.Radio
          label={label}
          value={value}
          checked={value === inputValue}
          disabled={disabled}
          onChange={e => onChange({ name, value })}
          key={value}
        />
      ))}
    </div>
  )
}
